const LANGUAGE_STORAGE_KEY = 'uplus_lang'
const LEGACY_LANGUAGE_STORAGE_KEY = 'language'

export const LANGUAGE_OPTIONS = Object.freeze([
  { code: 'zh-CN', apiCode: 'zh', label: '简体中文' },
  { code: 'zh-HK', apiCode: 'zh-HK', label: '繁體中文' },
  { code: 'en', apiCode: 'en', label: 'English' },
  { code: 'ko', apiCode: 'ko', label: '한국어' }
])

const LANGUAGE_ALIASES = {
  'zh': 'zh-CN',
  'zh-cn': 'zh-CN',
  'zh_cn': 'zh-CN',
  '简体中文': 'zh-CN',
  '簡體中文': 'zh-CN',
  'zh-hk': 'zh-HK',
  'zh_hk': 'zh-HK',
  '繁體中文': 'zh-HK',
  '香港繁體': 'zh-HK',
  'en': 'en',
  'en-us': 'en',
  'en_us': 'en',
  'english': 'en',
  'ko': 'ko',
  'ko-kr': 'ko',
  'ko_kr': 'ko',
  'kn': 'ko',
  '한국어': 'ko',
  '韩文': 'ko',
  '韓文': 'ko',
  'korean': 'ko'
}

export function normalizeLanguage(value) {
  const source = String(value || '').trim()
  if (!source) return 'zh-CN'
  return LANGUAGE_ALIASES[source.toLowerCase()] || LANGUAGE_ALIASES[source] || 'zh-CN'
}

export function readLanguage() {
  if (typeof window === 'undefined') return 'zh-CN'
  const queryLanguage = new URLSearchParams(window.location.search).get('lang')
  if (queryLanguage) return normalizeLanguage(queryLanguage)
  const current = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  const legacy = window.localStorage.getItem(LEGACY_LANGUAGE_STORAGE_KEY)
  return normalizeLanguage(current || legacy)
}

export function languageLabel(code) {
  const normalized = normalizeLanguage(code)
  const option = LANGUAGE_OPTIONS.find(item => item.code === normalized)
  return option ? option.label : LANGUAGE_OPTIONS[0].label
}

export function languageRequestCode(code) {
  const normalized = normalizeLanguage(code)
  const option = LANGUAGE_OPTIONS.find(item => item.code === normalized)
  return option ? option.code : LANGUAGE_OPTIONS[0].code
}

export function languageApiLocale(code) {
  const normalized = normalizeLanguage(code)
  if (normalized === 'en') return 'en_US'
  if (normalized === 'ko') return 'ko_KR'
  if (normalized === 'zh-HK') return 'zh_HK'
  return 'zh_CN'
}

export function languageIntlLocale(code = readLanguage()) {
  const normalized = normalizeLanguage(code)
  if (normalized === 'en') return 'en-US'
  if (normalized === 'ko') return 'ko-KR'
  if (normalized === 'zh-HK') return 'zh-HK'
  return 'zh-CN'
}

export function saveLanguage(code) {
  const normalized = normalizeLanguage(code)
  if (typeof window !== 'undefined') {
    const option = LANGUAGE_OPTIONS.find(item => item.code === normalized) || LANGUAGE_OPTIONS[0]
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, option.apiCode)
    window.localStorage.setItem(LEGACY_LANGUAGE_STORAGE_KEY, option.label)
    window.dispatchEvent(new CustomEvent('uplus-language-change', { detail: normalized }))
  }
  return normalized
}
